import(/* webpackMode: "eager" */ "/Users/arowaisi/Documents/ManaPNL/Frontend/src/app/(other)/auth/login/page.tsx");
